/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2023-08-08 19:38:44
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2023-08-15 16:52:44
 * @FilePath: \Client\src\apis\banner.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { req, post } from '@/plugins/axios'

/**
* 获取banner列表
* @param {Object} data
*/
export function getBannerList (data: any) {
  return req('/customer/banner/show', data)
}

/**
 * @param id bannerid
 * @returns
 */
export function incrementBanner (id: number) {
  return post('/customer/banner/increment', { bannerId: id })
}
